import { ca } from '@cian/analytics';
import { ANALYTICS_PAGE_TYPE } from 'shared/constants/analytics';
import { IProduct } from 'shared/types/analytics';

interface IAnalyticsParams<T> {
  category?: string;
  action: string;
  label?: string;
  page?: T;
  products?: IProduct[];
}

interface ISendAnalyticsParams<T> extends IAnalyticsParams<T> {
  useLastProducts?: boolean;
}

export const sendAnalytics = <T>({
  useLastProducts = true,
  category = ANALYTICS_PAGE_TYPE,
  ...params
}: ISendAnalyticsParams<T & Record<string, unknown>>) => {
  const { page, ...restParams } = params;

  ca('eventSite', {
    name: 'oldevent',
    category,
    page,
    useLastProducts: useLastProducts && !params.products,
    ...restParams,
  });
};
